import { RemoveCircle } from "@mui/icons-material";
import { Alert, Box, IconButton, Stack, Typography } from "@mui/joy";

import { useVenueColorsQuery } from "@/hooks/venues";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { useModal } from "../modals/useModal";

export default function ManageColors() {
  const currentVenueUuid = useCurrentVenueUuid();
  const query = useVenueColorsQuery(currentVenueUuid);
  const { display: displayModal } = useModal();
  return (
    <Stack spacing={2} padding={2}>
      <Typography level="title-lg">Gym Colors</Typography>
      <Alert color="neutral">
        When you add a custom color on a route or circuit, it will be added to your gym’s color
        palette so you can easily reuse it.
      </Alert>
      <Stack spacing={2} flexWrap="wrap" direction="row">
        {query.data?.map((color) => (
          <Box
            key={color.uuid}
            sx={{
              backgroundColor: color.colors,
              borderRadius: "sm",
              border: "1px solid",
              borderColor: "neutral.200",
              padding: 2,
              width: 64,
              height: 64,
              display: "flex",
              justifyContent: "space-between",
              position: "relative",
              ".MuiIconButton-root": {
                display: "none",
                position: "absolute",
                top: -8,
                right: -8,
                width: "28px",
                height: "28px",
                minHeight: 0,
                minWidth: 0,
                padding: 0,
                paddingInline: 0,
                backgroundColor: "white",
                borderRadius: "50px",
              },
              "&:hover .MuiIconButton-root": {
                display: "flex",
              },
              ".MuiIconButton-root:hover": {
                color: "danger.500",
              },
            }}
          >
            <IconButton
              onClick={() => {
                displayModal("CONFIRM_DELETE_VENUE_COLOR", {
                  color,
                });
              }}
              size="sm"
            >
              <RemoveCircle />
            </IconButton>
          </Box>
        ))}
      </Stack>
      {/* <Box>
        <Button startDecorator={<Add />}>Add Color</Button>
      </Box> */}
    </Stack>
  );
}
